import { Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import Dashboard from '../shared/containers/dashboard/Dashboard';
import Layout from '../shared/Layout';
import LoadingSpinner from '../shared/components/loading-spinner/LoadingSpinner';
import FeatureLoader from './FeatureLoader';
import { ESelectionType } from '../shared/sharedEnums';

export const buildRoutes = () => {
	// Generate direct selection routes dynamically from ESelectionType
	const selectionRoutes = Object.values(ESelectionType)
		.filter((type) => type !== ESelectionType.None) // Exclude 'None'
		.map((selectionType) => ({
			path: `${selectionType.toLowerCase()}/:selectionParam`,
			element: <div />, // Just show empty or redirect
			caseSensitive: false,
		}));

	const routes = [
		{
			path: '/',
			element: <Layout />,
			caseSensitive: false,
			children: [
				// Root route - show nothing/default state when no feature or selection
				// {
				// 	index: true,
				// 	element: <div />, // Empty div - no dashboard, no content when nothing is selected
				// },
				
				// Direct selection routes (e.g., /Vessel/123, /Portfolio/456) - no feature, no dashboard
				// Place these BEFORE the feature routes to avoid conflicts
				...selectionRoutes,

				// Feature with selection routes (e.g., /Kpis/Vessel/123) - show dashboard
				{
					path: ':feature/:selectionType/:selectionParam/:tab?/:subtab?',
					element: (
						<Dashboard>
							<Suspense fallback={<LoadingSpinner size="lg" />}>
								<FeatureLoader />
							</Suspense>
						</Dashboard>
					),
					caseSensitive: false,
				},
				
				// Feature routes (e.g., /Kpis, /Green, /Value) - show dashboard
				{
					path: ':feature/:tab?/:subtab?',
					element: (
						<Dashboard>
							<Suspense fallback={<LoadingSpinner size="lg" />}>
								<FeatureLoader />
							</Suspense>
						</Dashboard>
					),
					caseSensitive: false,
				},				
			],
		},
		{ path: '*', element: <Navigate to="/" />, caseSensitive: false },
	];

	return routes;
};

const Router = () => {
	const element = useRoutes(buildRoutes());

	return element;
};
export default Router;
